import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  public clickRemoveButton(event: Event) {
    event.preventDefault();
    $('#election_vote_box_id').val('');
  }
}
